import React from 'react';
import { useFormikContext } from 'formik';
import styled from 'styled-components';
import { H1, P } from 'components/text';
import { FieldGroup, Checkbox, TextField } from 'components/forms';

const Terms = styled.div`
  padding: ${props => props.theme.paddingM};
  margin-bottom: ${props => props.theme.paddingM};
  background-color: ${props => props.theme.infoBackground};
  
  hr {
    border-color: ${props => props.theme.border};
    margin: ${props => props.theme.paddingS} 0;
  }
  
  label {
    margin-bottom: 0;
  }
  
  p {
    font-size: ${props => props.theme.fontSizeXS};
  }
`

const Finish = () => {
  const { values } = useFormikContext();
  
  return (
    <>
      <H1>Almost there!</H1>
      <Terms>
        <FieldGroup name="agree">
          <Checkbox name="agree">
            Check here to indicate that you have read and agree to the terms of the <a href="https://www.ledgerx.com/legal" target="_blank" rel="noopener noreferrer">LedgerX User Agreement/Participant Agreement</a>.
          </Checkbox>
        </FieldGroup>
        <hr />
        <P>
          By submitting this application, I, an Authorized Representative of the applicant, certify that the information enclosed is true and accurate to the best of my knowledge.
        </P>
        
        <TextField
          name="signature"
          label="Signature"
          required
        />
      </Terms>
      
      <FieldGroup name="referral_source" label="How did you hear about us?">
        <Checkbox name="referral_source" value="web">
          Web search
        </Checkbox>
        <Checkbox name="referral_source" value="twitter">
          Twitter
        </Checkbox>
        <Checkbox name="referral_source" value="facebook">
          Facebook
        </Checkbox>
        <Checkbox name="referral_source" value="instagram">
          Instagram
        </Checkbox>
        <Checkbox name="referral_source" value="producthunt">
          Product Hunt
        </Checkbox>
        <Checkbox name="referral_source" value="news">
          News article
        </Checkbox>
        <Checkbox name="referral_source" value="podcast">
          Podcast
        </Checkbox>
        <Checkbox name="referral_source" value="blog">
          Blog
        </Checkbox>
        <Checkbox name="referral_source" value="referral">
          Referral
        </Checkbox>
        <Checkbox name="referral_source" value="other">
          Other
        </Checkbox>
        { values.referral_source && values.referral_source.includes('other') &&
          <TextField
            name="referral_source_other"
            placeholder="Please specify"
          />
        }
      </FieldGroup>
    </>
  );
};

export default Finish;
